<nz-layout>
  @if (load) {
    <nz-content class="bg-white container-blocks">
      <!-- Blocco 1 -->
      @if (!!contentPage.blocco1) {
        <div nz-row nzJustify="center" nzAlign="middle" class="padding-first-block">
          @if (!isPhonePortrait) {
            <div nz-col nzXs="24" nzSm="24" nzMd="12" nzLg="12" nzXl="12">
              <div class="blocco1-padding-h20">
                <p class="first-title">{{ contentPage.blocco1.fields?.items[0]?.topTitle }}</p>
                <h4 nz-typography class="text-primary subtitleSize" style="margin-bottom: 15px">{{ contentPage.blocco1.fields?.items[0]?.subTitle }}</h4>

                <nz-anchor [nzAffix]="false">
                  <nz-link nzHref="#cards" [nzTitle]="abbonatiButton" class="padding-left-0">
                    <ng-template #abbonatiButton>
                      <ds-button [text]="contentPage.blocco1.fields?.items[0]?.button" [iconRight]="'/public/assets/images/arrow-right-white.svg'" [width]="'medium'" [styleType]="'default-main'" class="bg-primary"></ds-button>
                    </ng-template>
                  </nz-link>
                </nz-anchor>
              </div>
            </div>

            <div class="container-img-bl1" nz-col nzXs="24" nzSm="24" nzMd="12" nzLg="12" nzXl="12">
              <img nz-image nzSrc="{{ contentPage.blocco1.fields?.items[0]?.image?.fields?.file.url }}" alt="" class="full-img-height-bl1" />
            </div>
          } @else {
            <div nz-col>
              <img nz-image nzSrc="{{ contentPage.blocco1.fields?.items[0]?.image?.fields?.file.url }}" alt="" style="width: 35rem; margin-left: -100px" class="full-img-height" />
            </div>

            <div nz-col>
              <div style="padding: 0 5%">
                <p nz-typography class="first-title">{{ contentPage.blocco1.fields?.items[0]?.topTitle }}</p>
                <h4 nz-typography class="text-primary">{{ contentPage.blocco1.fields?.items[0]?.subTitle }}</h4>

                <nz-anchor [nzAffix]="false">
                  <nz-link nzHref="#cards" [nzTitle]="abbonatiButton" class="padding-left-0">
                    <ng-template #abbonatiButton>
                      <ds-button [text]="contentPage.blocco1.fields?.items[0]?.button" [iconRight]="'/public/assets/images/arrow-right-white.svg'" [width]="'medium'" [styleType]="'default-main'" class="bg-primary"></ds-button>
                    </ng-template>
                  </nz-link>
                </nz-anchor>
              </div>
            </div>
          }
        </div>

        <div nz-row nzJustify="center" nzAlign="middle" style="background-color: #1a2bc2; padding: 4em 0" class="padding-gap-32-block">
          <div nz-col>
            <div class="padding-h20 text-center">
              <p nz-typography class="font-size-46" style="color: #ffffff !important;">{{ contentPage.blocco1.fields?.items[0]?.footerTitle }}</p>
              <p nz-typography class="font-size-16" style="color: #ffffff !important;">{{ contentPage.blocco1.fields?.items[0]?.footerSubTitle }}</p>
            </div>
          </div>
        </div>
      }
      <!-- End Blocco 1 -->

      <!-- Blocco 2 -->
      @if (!!contentPage.blocco2) {
        <div class="padding-block">
          <div nz-row style="padding: 0 0 2em" nzJustify="center" nzAlign="middle">
            <div nz-col class="padding-h20 text-center">
              <p nz-typography class="font-size-46" style="margin-bottom: 25px">{{ contentPage.blocco2.fields?.items[0]?.topTitle }}</p>
              <p nz-typography class="font-size-18 bl1">{{ contentPage.blocco2.fields?.items[0]?.subTitle }}</p>
            </div>
          </div>

          <div class="bg-white padding-consulta">
            <div nz-row class="border-radius" style="background-color: #EDEDEB">
              <div nz-col [nzSpan]="isPhonePortrait ? '24' : '10'" class="img-consulta">
                @if (isPhonePortrait) {
                  <img class="noClickImg" style="border-radius: 0 115px" nz-image width="100%" nzSrc="{{ contentPage.blocco2.fields?.items[0]?.image?.fields?.file.url }}" alt="" />
                } @else {
                  <img class="noClickImg" style="border-radius: 0 115px" nz-image width="93%" nzSrc="{{ contentPage.blocco2.fields?.items[0]?.image?.fields?.file.url }}" alt="" />
                }
              </div>

              <div nz-col [nzSpan]="isPhonePortrait ? '24' : '14'" class="blocco-consulta">
                <p nz-typography class="font-size-16">{{ contentPage.blocco2.fields?.items[0]?.listTitle }}</p>
              </div>
            </div>
          </div>
        </div>
      }
      <!-- End Blocco 2 -->

      <!-- Blocco 3 -->
      @if (!!contentPage.blocco3) {
        <div class="padding-gap-32-block">
          <div nz-row class="padding-row" nzJustify="center" nzAlign="middle">
            <div nz-col class="text-center">
              <p nz-typography class="font-size-46">{{ contentPage.blocco3.fields?.items[0]?.topTitle }}</p>
              <p nz-typography class="font-size-18">{{ contentPage.blocco3.fields?.items[0]?.subTitle }}</p>
            </div>
          </div>

          <div nz-row nzJustify="center" nzAlign="middle" [nzGutter]="24" class="container-card-number">
            @for (item of contentPage.blocco3.fields?.items[0]?.networkCenter; track $index) {
              <div nz-col [nzSpan]="isPhonePortrait ? '24' : '8'" [style]="isPhonePortrait ? 'padding: 5% 0' : 'padding: 5% 9%'">
                <nz-card class="bg-number-card border-radius-new text-center card-number">
                  <h1 class="text-primary font-size-50">
                    {{ item.numberCenter }}
                  </h1>
                  <p style="color: var(--text)" class="font-size-16">{{ item.titleCenter }}</p>
                </nz-card>
              </div>
            }
          </div>

          <div nz-row class="padding-3-block" nzJustify="center" nzAlign="middle">
            <div nz-col class="text-center">
              <h3 class="font-size-20" nz-typography>{{ contentPage.blocco3.fields?.items[0]?.footer }}</h3>
            </div>
          </div>
        </div>
      }
      <!-- End Blocco 3 -->

      @if (!!contentPage.blocco4) {
        <!-- Blocco 4 -->
        <div nz-row class="padding-blue-banner" style="background: #1a2bc2;" nzJustify="center" nzAlign="middle">
          <div nz-col class="text-center">
            <h2 nz-typography class="font-size-24-white">{{ contentPage.blocco4.fields?.items[0]?.topTitle }}</h2>
            <p class="font-size-16 blue-banner-subtitle">{{ contentPage.blocco4.fields?.items[0]?.subTitle }}</p>
            <nz-anchor [nzAffix]="false" [nzContainer]="">
              <nz-link nzHref="#cards" [nzTitle]="abbonatiButton2" class="padding-left-0">
                <ng-template #abbonatiButton2>
                  <ds-button [text]="contentPage.blocco4.fields?.items[0]?.button" [iconRight]="'/public/assets/images/arrow-right.svg'" [width]="'medium'" [styleType]="'empty-main'" class="border-primary bg-white btn-white"></ds-button>
                </ng-template>
              </nz-link>
            </nz-anchor>
          </div>
        </div>
      }
      <!-- End Blocco 4 -->

      <!-- Blocco 5 -->
      @if (!!contentPage.blocco5) {
        <div nz-row [style]="isPhonePortrait ? 'padding: 64px 5% 40px 5%;' : 'padding: 64px 9%;'" style="justify-content: space-around">
          <div nz-col [nzXs]="24" nzMd="11" nzLg="11" nzXl="11" [nzSm]="24" style="margin-top: auto; margin-bottom: auto">
            <p nz-typography class="font-size-30 title-bl5">{{ contentPage.blocco5.fields?.items[0]?.topTitle }}</p>
            <p nz-typography class="subtitle-bl5" style="line-height: 22px">{{ contentPage.blocco5.fields?.items[0]?.subTitle }}</p>
          </div>

          <div nz-col [nzXs]="24" [nzSm]="24" nzMd="10" nzLg="10" nzXl="10" class="container-card-cartella padding-cartella">
            @for (item of contentPage.blocco5.fields?.items[0]?.cureBox; track $index) {
              <div nz-col style="margin-bottom: 1.5em">
                <nz-card class="border-radius-new card-cartella" style="background-color: #BFD6FF;">
                  <div nz-col nzSpan="5" style="padding-right: 2%">
                    <img nz-image class="noClickImg" [width]="isPhonePortrait ? '60' : '70'" nzSrc="{{ item.image?.fields?.file.url }}" />
                  </div>
                  <div nz-col nzSpan="19" style="display: inline-block">
                    <p class="title-card">{{ item.title }}</p>
                    <p class="font-size-14">{{ item.subtitle }}</p>
                  </div>
                </nz-card>
              </div>
            }
          </div>
        </div>
      }
      <!-- End Blocco 5 -->

      @if (!!contentPage.blocco6) {
        <!-- Blocco 6 -->
        <div nz-row class="padding-pricing-block" style="background-color: #EDEDEB" nzJustify="center" nzAlign="middle" id="cards">
          <div nz-col>
            <p nz-typography class="text-center font-size-30">{{ contentPage.blocco6.fields?.items[0]?.topTitle }}</p>
            <p class="text-center font-size-14" style="margin-bottom: 2em; padding: 0 !important">{{ contentPage.blocco6.fields?.items[0]?.subTitle }}</p>
            <div [style]="isPhonePortrait ? 'padding: 0;' : 'padding: 0 15%;'">
              <div nz-row [nzGutter]="isPhonePortrait ? '' : '12'" class="d-center">
                @for (item of contentPage.blocco6.fields?.items[0]?.subscriptionList; track $index) {
                  <div nz-col [nzSpan]="isPhonePortrait ? '' : '12'" [style]="isPhonePortrait ? 'padding: 24px 0 24px 0' : ''">
                    <nz-card class="border-radius-card-price card-price" style="background-color: #EDEDEB">
                      <p class="text-primary title-card-price">{{ item.title }}</p>
                      <p style="margin-top: 5px" [innerHtml]="_returnHtmlFromRichText(item.subTitle)"></p>
                      <h1 style="padding-top: 0.7em">
                        <span style="color: var(--buttons-color); font-size: 50px">€</span>
                        <strong class="font-size-64">{{ item.price }}</strong>
                        <span style="color: var(--text)" class="font-size-16">{{ item.fractionation }}</span>
                      </h1>
                      <ds-button [text]="item?.dynamicButton?.content[0].content[1].content[0].value" [width]="'medium'" [styleType]="'default-main'" class="bg-primary pricing-subscribe-button" (click)="onSubscribeClick(item.title, item.dynamicButton?.content[0]?.content[1]?.data.uri)"></ds-button>
                      <div class="font-list-20" [innerHtml]="_returnHtmlFromRichText(item.list1)"></div>
                      <nz-divider style="border-color: #ccd1d9"></nz-divider>
                      <div nz-row [nzGutter]="24">
                        @for (item2 of item.list2; track $index) {
                          <div nz-col [nzSpan]="24" style="padding-bottom: 2em; font-size: 14px; line-height: 24px">
                            <span
                              nz-icon
                              nzType="check-circle"
                              nzTheme="outline"
                              style="color: var(--buttons-color); padding-right: 0.5em; font-size: 24px; line-height: 24px"
                            ></span>
                            {{ item2 }}
                          </div>
                        }
                      </div>
                    </nz-card>
                  </div>
                }
              </div>
            </div>
          </div>
        </div>
      }
      <!-- End Blocco 6 -->

      <!-- Blocco 7 -->
      @if (!!contentPage.blocco7) {
        <div nz-row class="last-block-container padding-who-are-block">
          <div nz-col [nzSpan]="isPhonePortrait ? '' : '14'" style="margin-top: auto; margin-bottom: auto; gap: 8px">
            <p class="font-size-30" nz-typography>{{ contentPage.blocco7.fields?.items[0]?.topTitle }}</p>
            <p nz-typography class="font-size-14" [innerHtml]="_returnHtmlFromRichText(contentPage.blocco7.fields?.items[0]?.subTitle)"></p>
          </div>

          <div nz-col [nzSpan]="isPhonePortrait ? '' : '9'" style="padding: 3%; width: 70%; margin: auto">
            <div nz-col style="margin-bottom: 1.5em">
              <img
                nz-image
                [style]="isPhonePortrait ? 'width: 100%;' : ''"
                nzSrc="{{ contentPage.blocco7.fields?.items[0]?.image?.fields?.file.url }}"
                alt=""
                class="full-img-height noClickImg"
              />
            </div>
          </div>
        </div>
      }
      <!-- End Blocco 7 -->
    </nz-content>
  }
</nz-layout>
